export default __webpack_public_path__ + "static/media/sec4contentimg1.f1815929.png";